// extracted by mini-css-extract-plugin
module.exports = {"loader":"Landing_loader___Ud4a"};